export default __webpack_public_path__ + "static/media/detgame.1435414b.png";